import _slicedToArray from "/Users/gf/six7-house/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["calendars", "value", "onChange", "mask", "startText", "endText", "inputFormat", "minDate", "maxDate"];
import * as React from 'react';
import { useThemeProps } from '@mui/material/styles';
import { ResponsiveTooltipWrapper } from '../internal/pickers/wrappers/ResponsiveWrapper';
import { useDefaultDates, useUtils } from '../internal/pickers/hooks/useUtils';
import { useDateRangeValidation } from '../internal/pickers/hooks/useValidation';
import { usePickerState } from '../internal/pickers/hooks/usePickerState';
import { DateRangePickerView } from './DateRangePickerView';
import DateRangePickerInput from './DateRangePickerInput';
import { parseRangeInputValue } from '../internal/pickers/date-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var KeyboardDateInputComponent = DateRangePickerInput;
var PureDateInputComponent = DateRangePickerInput;
var rangePickerValueManager = {
  emptyValue: [null, null],
  parseInput: parseRangeInputValue,
  areValuesEqual: function areValuesEqual(utils, a, b) {
    return utils.isEqual(a[0], b[0]) && utils.isEqual(a[1], b[1]);
  }
};
/**
 *
 * Demos:
 *
 * - [Date Range Picker](https://mui.com/components/date-range-picker/)
 *
 * API:
 *
 * - [DateRangePicker API](https://mui.com/api/date-range-picker/)
 */

var DateRangePicker = /*#__PURE__*/React.forwardRef(function DateRangePicker(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiDateRangePicker'
  });

  var _props$calendars = props.calendars,
      calendars = _props$calendars === void 0 ? 2 : _props$calendars,
      value = props.value,
      onChange = props.onChange,
      _props$mask = props.mask,
      mask = _props$mask === void 0 ? '__/__/____' : _props$mask,
      _props$startText = props.startText,
      startText = _props$startText === void 0 ? 'Start' : _props$startText,
      _props$endText = props.endText,
      endText = _props$endText === void 0 ? 'End' : _props$endText,
      passedInputFormat = props.inputFormat,
      minDateProp = props.minDate,
      maxDateProp = props.maxDate,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var utils = useUtils();
  var defaultDates = useDefaultDates();
  var minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
  var maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate;

  var _React$useState = React.useState('start'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentlySelectingRangeEnd = _React$useState2[0],
      setCurrentlySelectingRangeEnd = _React$useState2[1];

  var pickerStateProps = _extends({}, other, {
    value: value,
    onChange: onChange
  });

  var restProps = _extends({}, other, {
    minDate: minDate,
    maxDate: maxDate
  });

  var _usePickerState = usePickerState(pickerStateProps, rangePickerValueManager),
      pickerProps = _usePickerState.pickerProps,
      inputProps = _usePickerState.inputProps,
      wrapperProps = _usePickerState.wrapperProps;

  var validationError = useDateRangeValidation(props);

  var DateInputProps = _extends({}, inputProps, restProps, {
    currentlySelectingRangeEnd: currentlySelectingRangeEnd,
    inputFormat: passedInputFormat || utils.formats.keyboardDate,
    setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
    startText: startText,
    endText: endText,
    mask: mask,
    validationError: validationError,
    ref: ref
  });

  return /*#__PURE__*/_jsx(ResponsiveTooltipWrapper, _extends({}, restProps, wrapperProps, {
    DateInputProps: DateInputProps,
    KeyboardDateInputComponent: KeyboardDateInputComponent,
    PureDateInputComponent: PureDateInputComponent,
    children: /*#__PURE__*/_jsx(DateRangePickerView, _extends({
      open: wrapperProps.open,
      DateInputProps: DateInputProps,
      calendars: calendars,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
      startText: startText,
      endText: endText
    }, pickerProps, restProps))
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default DateRangePicker;